export default {
    setAirports(state, airports) {
        state.airports = airports;
    },

}